'use strict';
var moment = require('moment');
var validation = require('./forms/validation');

module.exports = {

    browserIE: function browserIE() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // If Internet Explorer, return true
        {
            return true;
        } else {
            return false;
        }
    },

    disallowNegatives: function disallowNegatives(e) {
        if (!((e.keyCode > 95 && e.keyCode < 106)
            || (e.keyCode > 47 && e.keyCode < 58)
            || e.keyCode === 8)) {
            return false;
        }
    },

    formatdate: function formatdate(date) {
        if (validation.isNullOrEmpty(date)) {
            return '';
        }
        return moment(date).format('MM/DD/YYYY');
    },

    getParameterByName : function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
}